// pages/DashboardPage.jsx
import React from 'react';
import Layout from '../components/common/Layout';
import ReservationsList from '../components/dashboard/ReservationsList';
import PinDisplay from '../components/dashboard/PinDisplay';
import UserInfo from '../components/dashboard/UserInfo';
import { useReservations } from '../hooks/useReservations'; // named export olarak import
import useAuth from '../hooks/useAuth'; // default export olarak import
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';
import Card from '../components/common/Card';

const DashboardPage = () => {
  const { user } = useAuth();
  const { 
    bookings: reservations, 
    loading, 
    error, 
    cancelReservation 
  } = useReservations();
  
  // Find today's reservations for PIN display (all of them, not just one)
  const today = new Date();
  const todayReservations = reservations?.filter(res => {
    // Firestore Timestamp veya Date kontrolü
    let resDate;
    if (res.date?.toDate) {
      resDate = res.date.toDate();
    } else if (res.dateString) {
      resDate = new Date(res.dateString);
    } else {
      resDate = new Date(res.date);
    }
    
    return (
      resDate.getDate() === today.getDate() &&
      resDate.getMonth() === today.getMonth() &&
      resDate.getFullYear() === today.getFullYear() &&
      res.status !== 'cancelled'
    );
  })?.sort((a, b) => {
    // Başlangıç saatine göre sırala
    const timeA = a.startTime || '00:00';
    const timeB = b.startTime || '00:00';
    return timeA.localeCompare(timeB);
  }) || [];
  
  return (
    <Layout>
      <div className="mb-8 flex justify-between items-center fade-in">
        <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-500 flex items-center">
          <svg className="w-8 h-8 mr-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          Kullanıcı Paneli
        </h1>
        <Link to="/reserve">
          <Button variant="primary" className="flex items-center hover-scale">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Yeni Rezervasyon
          </Button>
        </Link>
      </div>
      
      {error && (
        <div className="bg-red-900 bg-opacity-80 border border-red-500 text-red-100 px-6 py-4 rounded-lg mb-6 shadow-lg slide-up">
          <div className="flex">
            <svg className="w-6 h-6 text-red-300 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>{error}</p>
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          {todayReservations.length > 0 ? (
            todayReservations.map((res, index) => (
              <PinDisplay key={res.id || index} pin={res.pin} reservation={res} />
            ))
          ) : (
            <PinDisplay pin={null} reservation={null} />
          )}
          <ReservationsList
            reservations={reservations || []}
            loading={loading}
            onCancel={cancelReservation}
          />
        </div>
        
        <div className="space-y-6">
          <UserInfo />
          
          <Card title="Müzik Odası Kuralları" className="card fade-in">
            <div className="space-y-4">
                <div className="flex">
                <div className="flex-shrink-0">
                    <svg className="w-6 h-6 text-blue-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <div className="flex-1">
                    <h3 className="text-sm font-semibold text-blue-100 mb-2 gradient-text">Bilgilendirme</h3>
                    <p className="text-sm text-blue-200">
                    Müzik odası öğrencilerin pratik yapması ve müzik etkinlikleri düzenlemesi için tasarlanmıştır.
                    </p>
                </div>
                </div>

                <ul className="space-y-2 text-sm text-gray-100">
                <li className="flex items-start bg-gray-800 bg-opacity-70 p-3 rounded-lg border border-gray-600 hover-scale transition-all duration-200">
                    <svg className="w-5 h-5 text-blue-400 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Rezervasyon saatlerine uyunuz, geç kalma durumunda rezervasyonunuz iptal edilebilir.</span>
                </li>
                <li className="flex items-start bg-gray-800 bg-opacity-70 p-3 rounded-lg border border-gray-600 hover-scale transition-all duration-200">
                    <svg className="w-5 h-5 text-blue-400 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Odayı kullanırken temiz bırakınız ve aletleri toparlayınız.</span>
                </li>
                <li className="flex items-start bg-gray-800 bg-opacity-70 p-3 rounded-lg border border-gray-600 hover-scale transition-all duration-200">
                    <svg className="w-5 h-5 text-blue-400 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Müzik aletlerini kullanım kılavuzlarına uygun şekilde kullanınız.</span>
                </li>
                <li className="flex items-start bg-gray-800 bg-opacity-70 p-3 rounded-lg border border-gray-600 hover-scale transition-all duration-200">
                    <svg className="w-5 h-5 text-red-400 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    <span>PIN kodunuzu başkalarıyla paylaşmayınız, güvenlik ihlali durumunda sorumluluk size aittir.</span>
                </li>
                </ul>
            </div>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default DashboardPage;